import { getApiUrl } from "@commons-monorepo/index";

const headers = {
  "Content-Type": "application/json",
  Accept: "application/json",
} as HeadersInit;

export const sendSubscription = async (
  partnerId: string,
  email: string,
): Promise<string | undefined> => {
  const response = await fetch(
    `${getApiUrl()}/api/ms/offer/offer-addon/${partnerId}/customer`,
    {
      method: "POST",
      headers: headers,
      body: JSON.stringify({ email }),
    },
  )
    .then((res) => res.json())
    .catch(() => {
      return;
    });
  return response?.offer_code;
};
